import { getItem, removeItem } from '../../helpers/storage';
import { useHistory } from 'react-router';

export const Logout = () => {
    const history = useHistory();
    if (getItem('originalUser')) {
        removeItem('originalUser');
    }
    removeItem('user');
    history.push('/');
    history.go(0);
    return null;
};
